import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet><ngx-spinner type="ball-clip-rotate" size="medium" color="#5ba7ea"></ngx-spinner>`
})
export class RootComponent {

}
